// List of Cairo districts
export const cairoDistricts = {
  en: [
    "Saba Pasha",
    "Bolkly",
    "Roushdy",
    "Stanley",
    "San Stefano",
    "Laurent",
    "Mustafa Kamel",
    "Sidi Gaber",
    "Camp Caesar",
    "Sporting",
    "Cleopatra",
    "Ibrahimia",
    "Shatby",
    "Kafr Abdo",
    "Fleming",
    "Zizinia",
    "Gianaclis",
    "Shods",
    "Safar",
    "Bacchus",
    "Azarita",
    "Smouha",
  ],
  ar: [
    "سابا باشا",
    "بولكلي",
    "رشدي",
    "ستانلي",
    "سان ستيفانو",
    "لوران",
    "مصطفى كامل",
    "سيدي جابر",
    "كامب شيزار",
    "سبورتنج",
    "كليوباترا",
    "الإبراهيمية",
    "الشاطبي",
    "كفر عبده",
    "فلمنج",
    "زيزينيا",
    "جناكليس",
    "شدس",
    "سافر",
    "باكوس",
    "الأزاريطة",
    "سموحة",
  ],
};

// Reservation status options
export const reservationStatus = {
  PENDING: "pending",
  FULFILLED: "fulfilled",
  DENIED: "denied",
  CANCELLED: "cancelled",
};

// Visit types
export const visitTypes = {
  URGENT: "urgent",
  SCHEDULED: "scheduled",
};
